module.exports = __webpack_public_path__ + "img/lock-on.d1d1dbfd.svg";